import type { SxProps, Theme } from "@mui/material/styles";

export const form: SxProps<Theme> = {
  gap: 2.75,
};

export const termsNote: SxProps<Theme> = {
  textAlign: "center",
  mt: 2.75,
  fontSize: "0.78125rem",
  color: "text.secondary",
  lineHeight: 1.8,
};

export const termsLink: SxProps<Theme> = {
  color: "primary.main",
  fontWeight: 600,
  textDecoration: "none",
  cursor: "pointer",
  border: "none",
  bgcolor: "transparent",
  p: 0,
  fontFamily: "inherit",
  display: "inline",
};
